import React, { useState, useRef, useEffect } from 'react';
import PropType from 'prop-types';
import Select from 'react-select';

const FilterDropDown = ({ label, options, onChange, isEnabled, action, isSearchable }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [displayLabel, setDisplayLabel] = useState(label);
    const [defaultLabel] = useState(label);
    const [previousState, setPreviousState] = useState({ label: label, options: options});
    const [selectedOption, setSelectedOption] = useState(null); 
    const selectRef = useRef(null);
    
    function closeOptionsMenu(event) {
		// click outside of menus and content menus = close menus
		if (
			selectRef.current &&
            !selectRef.current.controlRef.contains(event.target) &&
			isExpanded
		) {
			setIsExpanded(false);
		}
	}
    document.addEventListener('mousedown', closeOptionsMenu);

    useEffect(() => {
        switch (action.type) {
            case FilterDropDown.ActionTypes.Clear:
                setDisplayLabel(previousState.label);   
                break;    
        
            case FilterDropDown.ActionTypes.Reset:
                setSelectedOption(null);
                setDisplayLabel(defaultLabel);   
                break;

            case FilterDropDown.ActionTypes.Apply:
                setPreviousState({ label: selectedOption?.label == null ? defaultLabel : selectedOption.label, options: options});
                break;

            case FilterDropDown.ActionTypes.NoAction:
                break;

            default:
                setDisplayLabel(defaultLabel);  
        }
    }, [action])

    useEffect(() => {
        if (previousState?.options !== options){
            setDisplayLabel(defaultLabel);  
        }
    }, [options])

    return (
        <div>
            <Select
                disabled={!isEnabled}  
                ref={selectRef}
                isSearchable={isSearchable}
           
                classNames={{
                    control: () => 'form-control',
                    menuList: () => 'card',
                    option: (state) =>
                        state.isFocused ? 'bg-color-precision-grey text-white p-2' : 'p-2',
                }}
                components={{
                    IndicatorSeparator: () => null,
                }}
                onMenuClose={() => setIsExpanded(false)}
                onMenuOpen={() => setIsExpanded(true)}        
                menuIsOpen={isExpanded}
                onChange={(option) => {setIsExpanded(false); onChange(option); setDisplayLabel(option.label); setSelectedOption(option); }} 
                placeholder={displayLabel}
                options={options}
                value={displayLabel}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
            >
            </Select>
        </div>
    )
}

FilterDropDown.ActionTypes = {
    NoAction: "nonaction",
    Reset: "reset",
    Clear: "clear",
    Apply: "apply"
}

FilterDropDown.propTypes = {
    label: PropType.string,
    options: PropType.array,
    onChange: PropType.func,
    isEnabled: PropType.bool,
    action: PropType.object,
    isSearchable: PropType.bool
}

FilterDropDown.SetAction = (actionType, data) => {
    return {type: actionType, data: data, timestamp: new Date().toISOString()};
}
FilterDropDown.SetAction.prototype = {
    actionType: PropType.oneOf(["", FilterDropDown.ActionTypes.Reset, FilterDropDown.ActionTypes.Clear, FilterDropDown.ActionTypes.Apply, FilterDropDown.ActionTypes.NoAction]),
    data: PropType.object
}

export default FilterDropDown;